export default {
  cancelModalTitle: `Are you sure you want to cancel the changes you've made?`,
  cancelModalDescription:
    'By canceling these changes, your program will be reverted to it’s last save state and no changes will be saved.',
  cancelCancelButtonText: 'Never mind',
  cancelConfirmButtonText: `I'm Sure`,
};
